
interface SkeletonLineProps {
  readonly className?: string;
}

export function SkeletonLine({ className = '' }: SkeletonLineProps) {
  return <div className={`animate-pulse rounded-md bg-cool-gray-800 h-7 w-full ${className}`} />;
}
